<script>
  let { 
    /** @type {number | string} */
    number,
    class: css_class
  } = $props();
  
  const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  
  function is_numeric(char) {
    return !isNaN(parseInt(char)) && char !== ' ';
  }
</script>

<p 
  class="flex-row number-change-container {css_class}"
  aria-label={number.toString()}
  aria-live="polite"
>
  {#each number.toString().split('') as char, index}
    {#if is_numeric(char)}
      <span 
        class="digit-container animate-container"
        class:last-digit={index === number.toString().length - 1}
        style:--offset={`${-parseInt(char) * 1}em`}
        aria-hidden="true"
      >
        {#each DIGITS as digit}
          <span class="digit character">
            {digit}
          </span>
        {/each}
      </span>
    {:else}
      <span class="static-char character" aria-hidden="true">
        {char}
      </span>
    {/if}
  {/each}
</p>

<style>
  .number-change-container {
    overflow: hidden;
    display: inline-flex;
    align-items: baseline;
    height: var(--font-size);
  }

  .digit-container {
    display: inline-flex;
    flex-direction: column;
    height: var(--font-size);
    transform: translateY(0);
    text-align: center;
    /* This causes subtle display issues when resizing the browser, as the font-size is dynamic based on the viewport */
    /* TODO: find e.g. a way to disable transition when the viewport is resized */
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(var(--offset));
    will-change: transform;
  }
  .character {
    /* important: we must use the same unit for offset and height 
    (in Safari when mixing units, the digits will not align horizontally) */
    height: var(--font-size);
    line-height: var(--font-size);
    font-variant-numeric: tabular-nums;
  }

  .digit {
    width: 1ch; /* monospace */
    text-align: center;
    flex-shrink: 0;
  }
</style>